<template>
  <el-container>
    <el-header style="padding: 0">
      <Header :teleNum="teleNum" />
    </el-header>

    <el-main>
      <el-row :gutter="40" class="content">
        <el-col :span="6" :offset="5">
          <el-card
            class="box-card"
            shadow="always"
            @click.native="openAppointment"
            :body-style="{ padding: '0px' }"
          >
            <img :src="Imgs.Book_logo" class="indexImg" />
            <div style="padding: 14px">
              <h3 style="margin-bottom: 40px">网上预约</h3>
              <div class="bottom clearfix"></div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6" :offset="1">
          <el-card
            class="box-card"
            shadow="always"
            @click.native="openMyDiagnose"
            :body-style="{ padding: '0px' }"
          >
            <img :src="Imgs.Diagnose_logo" class="indexImg" />
            <div style="padding: 14px">
              <h3 style="margin-bottom: 40px">我的诊断</h3>
              <div class="bottom clearfix"></div>
            </div>
          </el-card>
        </el-col>



        <!-- <el-col :span="6" :offset="1">
          <el-card
            class="box-card"
            shadow="hover"
            @click.native="openMyDiagnose"
          >
            <h2>我的诊断</h2>
          </el-card>
        </el-col> -->
      </el-row>
    </el-main>

    <el-footer
      style="
        position: absolute;
        bottom: 0;
        width: 100%;
        height: auto;
        text-align: center;
        padding:0
      "
    >
      <img :src="Imgs.Hot_line" style="width:100%;height:auto"/>
      <!-- 欢迎拨打服务热线 0731-85231858 -->
    </el-footer>

    <el-dialog
      title="网上预约系统"
      :visible.sync="appointment.appointmentVisible"
      width="850px"
      center
    >
      <el-tabs
        v-model="tabs.activeName"
        :before-leave="tabBeforeLeave"
        class="tabPadding"
      >
        <el-tab-pane :label="tabs.userInfo.label" :name="tabs.userInfo.name">
          <el-form
            ref="form"
            label-width="120px"
            label-position="left"
            :model="formBasicInfo"
          >
            <el-form-item label="姓名">
              <el-input v-model="formBasicInfo.name"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="type">
              <el-radio-group v-model="formBasicInfo.gender">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="地区">
              <el-input v-model="formBasicInfo.address"></el-input>
            </el-form-item>
            <el-form-item label="出生日期">
              <el-col :span="24">
                <el-date-picker
                  v-model="formBasicInfo.birthDate"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                ></el-date-picker>
              </el-col>
            </el-form-item>
            <!-- <el-form-item label="联系电话">
              <el-input v-model="formBasicInfo.userInfoTeleNum"></el-input>
            </el-form-item> -->
            <el-form-item label="职业">
              <el-input v-model="formBasicInfo.profession"></el-input>
            </el-form-item>

            <el-form-item label="身高">
              <el-input v-model="formBasicInfo.height"></el-input>
            </el-form-item>
            <el-form-item label="体重">
              <el-input v-model="formBasicInfo.weight"></el-input>
            </el-form-item>
            <el-form-item label="是否已育">
              <el-select
                v-model="formBasicInfo.marriage"
                placeholder="..."
                class="fullWidth"
              >
                <el-option label="已生育" value="已生育"></el-option>
                <el-option label="未生育" value="未生育"></el-option>
              </el-select>
            </el-form-item>
            <br />
            <el-form-item style="float: right">
              <el-button type="primary" @click="doUpdateUserInfo"
                >保存</el-button
              >
              <el-button @click="appointment.appointmentVisible = false"
                >返回首页</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane
          :label="tabs.absoluteContradictions.label"
          :name="tabs.absoluteContradictions.name"
        >
          <h2>您是否有如下症状？</h2>
          <el-form
            ref="form"
            label-width="585px"
            label-position="left"
            :model="formContraindications"
          >
            <el-form-item
              label="急性心梗(2天内) 或心肌梗塞合并室壁瘤"
              class="_form_item"
            >
              <el-radio-group
                v-model="formContraindications.ac1"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="中、重度瓣膜病或先天性心脏病">
              <el-radio-group
                v-model="formContraindications.ac2"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="急性心肌炎、心包炎、风湿热、感染性心内膜炎">
              <el-radio-group
                v-model="formContraindications.ac3"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="严重高血压、显著低血压">
              <el-radio-group
                v-model="formContraindications.ac4"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="运动引起加重或影响运动的非心源性疾病">
              <el-radio-group
                v-model="formContraindications.ac5"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="未控制的不稳定型心绞痛、症状明显的心力衰竭">
              <el-radio-group
                v-model="formContraindications.ac6"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="产生症状或血流动力学障碍的未控制心律失常">
              <el-radio-group
                v-model="formContraindications.ac7"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="严重的主动脉狭窄">
              <el-radio-group
                v-model="formContraindications.ac8"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="肺栓塞、肺梗塞">
              <el-radio-group
                v-model="formContraindications.ac9"
                @change="unsuitableForTest"
              >
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="是否接受运动试验">
              <el-radio-group v-model="formContraindications.ac10">
                <el-radio label="否"></el-radio>
                <el-radio label="是"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label-width="200px" style="float: right">
              <el-button type="primary" @click="absoluteContradictionsNextStep"
                >下一步</el-button
              >
              <el-button @click="tabs.activeName = 'userInfo'"
                >返回上一页</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>

        <el-tab-pane
          :label="tabs.confirmAppointment.label"
          :name="tabs.confirmAppointment.name"
        >
          <el-form
            v-if="appointment.hasBooked"
            ref="form"
            style="text-align: center"
          >
            <el-form-item label="">
              <el-button type="primary" icon="el-icon-circle-check"></el-button>
            </el-form-item>
            <el-form-item label="">
              <h2>恭喜您!</h2>
              <h2>预约成功!</h2>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="_checkAppointmentInfo"
                >查看预约</el-button
              >
              <el-button @click="appointment.appointmentVisible = false"
                >返回首页</el-button
              >
            </el-form-item>
          </el-form>

          <el-form
            v-else
            ref="form"
            label-width="120px"
            label-position="left"
            :model="formAppointment"
          >
            <el-form-item label="预约日期">
              <el-date-picker
                class="fullWidth"
                v-model="formAppointment.date"
                type="date"
                placeholder="选择日期"
                format="yyyy-MM-dd"
                @change="_getMedResource"
              >
              </el-date-picker>
              <!-- <el-input v-model="formAppointment.date"></el-input> -->
            </el-form-item>
            <el-form-item label="预约时间">
              <el-row>
                <span v-if="medResources.length == 0" style="color: red"
                  >您选择的日期，无挂号资源</span
                >
                <el-col
                  :span="8"
                  v-for="(item, index) in medResources"
                  :key="index"
                  class="timeSelect"
                >
                  <el-button
                    type="primary"
                    plain
                    @click="timeSelect(item)"
                    :disabled="item.resourceLeft == 0"
                  >
                    {{ item.checkTime.split(" ")[1] }}
                  </el-button>
                  <!-- <el-radio
                    v-model="formAppointment.resourceUuid"
                    :label="item.resourceUuid"
                    border
                    >{{ item.checkTime.split(" ")[1] }}</el-radio
                  > -->
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="预约地点">
              <el-select
                v-model="formAppointment.orgUuid"
                placeholder="请选择"
                class="fullWidth"
              >
                <el-option
                  v-for="item in orgList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="备注">
              <el-input v-model="formAppointment.remark"></el-input>
            </el-form-item> -->

            <el-form-item style="float: right">
              <el-button type="primary" @click="_appointment"
                >确认预约</el-button
              >
              <el-button @click="tabs.activeName = 'absoluteContradictions'"
                >返回上一页</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <el-dialog
      title="我的预约信息"
      :visible.sync="appointment.myAppointmentInfoDialog"
      width="500px"
      center
      @open="_reloadClientBookInfo"
    >
      <el-form
        ref="form"
        label-width="120px"
        label-position="left"
        :model="formAppointment"
      >
        <el-form-item label="姓名">
          {{ myAppointmentInfo.name }}
          <!-- <el-input readonly :value="myAppointmentInfo.name"> </el-input> -->
        </el-form-item>
        <el-form-item label="年龄">
          {{ myAppointmentInfo.age }}
          <!-- <el-input readonly :value="myAppointmentInfo.age"> </el-input> -->
        </el-form-item>
        <el-form-item label="预约时间">
          {{ myAppointmentInfo.bookedTime }}
          <!-- <el-input readonly :value="myAppointmentInfo.bookedTime"> </el-input> -->
        </el-form-item>
        <el-form-item label="预约地点">
          {{ myAppointmentInfo.medResourceName }}
          <!-- <el-input readonly :value="myAppointmentInfo.medResourceName"></el-input> -->
        </el-form-item>
        <el-form-item label="预约凭证">
          {{ myAppointmentInfo.credential }}
          <!-- <el-input readonly :value="myAppointmentInfo.credential"> </el-input> -->
        </el-form-item>
        <el-form-item label="">
          <el-button type="danger" @click="_cancelBookedResource"
            >取消预约</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="我的诊断信息"
      :visible.sync="diagnose.diagnoseVisible"
      center
      v-if="diagnose.diagnoseVisible"
      width="1024px"
    >
      <!-- <h2>基本信息</h2> -->
      <section class="main-body">
        <ClientBasicInfo :teleNum="teleNum" />
        <br />
        <SelfStatement :teleNum="teleNum" :disabled="true" />
        <br />
        <!-- <Prescription :teleNum="teleNum"/> -->
        <el-row :gutter="20">
          <h3>检测结果及健康建议</h3>
          <div class="myBox">
            <span>
              {{ this.prescription }}
            </span>
          </div>
        </el-row>
      </section>
    </el-dialog>
  </el-container>
</template>

<script>
import Header from "../../../components/common/header";
import SelfStatement from "../../../components/common/selfStatement";
// import Prescription from "../../../components/common/Prescription";
import Moment from "moment";
import { medicalHistoryFormat } from "../../../utils/constants";

import {
  // getUserInfo,
  getCurrentUserByToken,
  getUserBookedResource,
  updateUserInfo,
  bookMedResource,
  cancelBookedResource,
  getUserAfterExam,
  // getUserExam,
  getUserAllExam,
} from "../../../api/userService";

import { getResource } from "../../../api/medCheckResourceService";
import ClientBasicInfo from "../../../components/common/ClientBasicInfo";
// import {Util_ageFormatter} from '../../../utils/util'
import { Formatter_ageFormatter } from "../../../utils/formatter";
// import Prescription from '../../../components/common/Prescription.vue';

//ASSETS Import
import Book_logo from "../../../assets/book-logo.png";
import Diagnose_logo from "../../../assets/diagnose-logo.png"
import Hot_line from "../../../assets/hot-line.png"

export default {
  name: "client",
  // props: {
  //   msg: String,
  // },
  components: {
    Header,
    ClientBasicInfo,
    SelfStatement,
    // Prescription,
  },
  data() {
    return {
      Imgs: {
        Book_logo: Book_logo,
        Diagnose_logo,
        Hot_line,
      },

      disabled: true,
      //预约选项卡
      tabs: {
        userInfo: {
          value: 1,
          label: "1-填写基本信息",
          name: "userInfo",
          ableToNextStep: false,
        },
        absoluteContradictions: {
          value: 2,
          label: "2-绝对禁忌症提示",
          name: "absoluteContradictions",
          ableToNextStep: true,
        },
        // medicalHistory: {
        //   value: 3,
        //   label: "3-填写既往病史",
        //   name: "medicalHistory",
        //   ableToNextStep: false,
        // },
        confirmAppointment: {
          value: 3,
          label: "4-确认预约",
          name: "confirmAppointment",
          ableToNextStep: false,
        },

        //默认 tabs 选项卡 1代表填写用户基本信息
        activeName: "userInfo",
      },
      //预约总体对象： 预约面板的开关、 预约中-预约成功 的切换
      appointment: {
        appointmentVisible: false,
        //默认 tabs 选项卡 1代表填写用户基本信息
        hasBooked: false,
        //我的预约信息面板开关
        myAppointmentInfoDialog: false,
      },
      myAppointmentInfo: {
        name: "",
        age: "",
        bookedTime: "",
        medResourceName: "",
        orgUuid: "1",
        credential: "",
      },
      //基础信息
      formBasicInfo: {
        name: "",
        address: "",
        birthDate: "",
        gender: "",
        height: "",
        marriage: "",
        profession: "",
        userInfoTeleNum: sessionStorage.getItem("teleNum"),
        weight: "",
      },
      //绝对禁忌症 - 有一项为“是”，则禁止预约
      formContraindications: {
        ac1: "否",
        ac2: "否",
        ac3: "否",
        ac4: "否",
        ac5: "否",
        ac6: "否",
        ac7: "否",
        ac8: "否",
        ac9: "否",
        ac10: "是",
      },

      //通过既往病史对象的key找到 name
      medicalHistoryFormat: medicalHistoryFormat,
      //col :span显示name的列数
      MedHistoryName: "",
      //col :span显示value的列数
      MedHistoryValue: 12,
      confirmedDisease: 12,
      confirmedDiseaseInputDisabled: true,
      drugName: "",
      drugNameInputDisabled: true,
      diagnose: {
        diagnoseVisible: false,
      },
      //预约表格
      formAppointment: {
        date: new Date(),
        time: "",
        checkTime: "",
        orgUuid: "1",
        resourceLeft: 0,
        resourceUuid: "",
        total: 0,
        // checkTime: "2020-10-21T03:44:53.383Z",
        orgId: "1",
      },
      //挂号资源
      medResources: [],
      //检测组织机构
      orgList: [{ label: "广电计量大厦15层中以生物", value: "1" }],
      afterExam: "",
      prescription: "",
      allExams: [],
    };
  },
  computed: {
    checkTime() {
      return this.appointment.date + " " + this.appointment.time;
    },
    teleNum() {
      if (this.$store.state.teleNum == "") {
        return sessionStorage.getItem("teleNum");
      }
      return this.$store.state.teleNum;
    },
  },

  methods: {
    //打开预约面板
    openAppointment() {
      this.appointment.appointmentVisible = true;
    },
    openMyDiagnose() {
      this.diagnose.diagnoseVisible = true;
    },
    //预约面板 中 点击tab，是否能跳转tab的限制
    tabBeforeLeave(newTab, oldTab) {
      //只能点下一个 而且确保前一个tab已经操作完，可以进入下一个
      if (
        this.tabs[newTab].value - this.tabs[oldTab].value == 1 &&
        this.tabs[oldTab].ableToNextStep
      ) {
        return true;
      }
      //如果点击的是之前的tabs则 允许
      else if (this.tabs[newTab].value - this.tabs[oldTab].value < 0) {
        return true;
      } else {
        this.$message({
          message: "请先完成当前的操作后，点击'保存'或'下一步'进入下一步骤！",
          type: "warning",
        });
        return false;
      }
    },
    // _getUserInfo() {
    //   //我的诊断中获取用户基本信息
    //   getUserInfo(this.teleNum ).then((res) => {
    //     // console.log(res);
    //     //基础信息
    //     if( res.data[0] ) {
    //       this.formBasicInfo = res.data[0];
    //     }
    //     //如果基础信息存在的话，说明已经录入过，则用户可以进入下一步
    //     if (this.formBasicInfo) {
    //       this.tabs.userInfo.ableToNextStep = true;
    //     }
    //   });
    // },

    //获取当前用户信息
    _getCurrentUser() {
      getCurrentUserByToken()
        .then((res) => {
          if (res.data[0].userInfo) {
            this.formBasicInfo = res.data[0].userInfo;
            //如果基础信息存在的话，说明已经录入过，则用户可以进入下一步
            this.tabs.userInfo.ableToNextStep = true;
          } else {
            this.tabs.userInfo.ableToNextStep = false;
            // this._getUserInfo()
          }
        })
        .catch((e) => {
          // this._getUserInfo()
          this.$message({
            message: "获取当前用户信息失败," + e,
            type: "error",
          });
        });
    },
    doUpdateUserInfo() {

      let formatForm = Object.assign({},this.formBasicInfo);
      formatForm.birthDate = Moment(formatForm.birthDate).format("YYYY-MM-DD HH:MM:SS");
      formatForm.weight = parseFloat(formatForm.weight);
      formatForm.height = parseFloat(formatForm.height);
      // console.log("form",this.form);
      console.log("formatForm",formatForm);

      updateUserInfo(JSON.stringify(formatForm))
        .then((res) => {
          if (res.success) {
            this.$message({ message: "更新用户基础信息成功", type: "success" });
            //更新用户信息显示
            this.formBasicInfo = res.data[0].userInfo;
            //更新用户基本信息成功后，设置可进入下一个tab
            this.tabs.userInfo.ableToNextStep = true;
            //进入绝对禁忌症Tab面板
            this.tabs.activeName = "absoluteContradictions";
          } else {
            //如果接口调用失败则 告知用户错误信息
            this.$message.error(res.description);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    unsuitableForTest(value) {
      //如果有绝对禁忌症
      if (value == "是") {
        //则提示不能做检查
        this.$message({
          message: "您有绝对禁忌症，不适合该项目的检查！",
          type: "warning",
        });
      }
    },
    absoluteContradictionsNextStep() {
      //如果没有绝对禁忌症
      if (
        this.formContraindications.ac1 == "否" &&
        this.formContraindications.ac2 == "否" &&
        this.formContraindications.ac3 == "否" &&
        this.formContraindications.ac4 == "否" &&
        this.formContraindications.ac5 == "否" &&
        this.formContraindications.ac6 == "否" &&
        this.formContraindications.ac7 == "否" &&
        this.formContraindications.ac8 == "否" &&
        this.formContraindications.ac9 == "否"
      ) {
        // 如果没有绝对禁忌症  但 不接受运动检测
        if (this.formContraindications.ac10 == "否") {
          this.$message({
            message: "由于您不接受运动测试，所以不能继续下一步操作！",
            type: "warning",
          });
        }
        //如果没有绝对禁忌症 且 接受 运动检测
        else {
          //绝对禁忌症tab一栏设置为可执行下一步
          this.tabs.absoluteContradictions.ableToNextStep = true;
          this.tabs.activeName = "confirmAppointment";
        }
      }
      //如果有绝对禁忌症
      else {
        this.tabs.absoluteContradictions.ableToNextStep = true;
        this.$message({
          message: "由于您有绝对禁忌症，所以不适合做该检测！",
          type: "warning",
        });
      }
    },
    //病史中选择了明确患有某种疾病
    selectConfirmedDisease(value) {
      if (value == "是") {
        this.confirmedDiseaseInputDisabled = false;
      } else {
        this.confirmedDisease = "";
        this.confirmedDiseaseInputDisabled = true;
      }
    },
    //病史中选择了明确患有某种疾病
    selectLongTimeDrug(value) {
      if (value == "是") {
        this.drugNameInputDisabled = false;
      } else {
        this.drugName = "";
        this.drugNameInputDisabled = true;
      }
    },
    //选择预约时间
    timeSelect(item) {
      this.formAppointment.checkTime = item.checkTime;
      this.formAppointment.orgId = item.orgId;
      this.formAppointment.resourceLeft = item.resourceLeft;
      this.formAppointment.resourceUuid = item.resourceUuid;
      this.formAppointment.total = item.total;
    },

    //根据检测地点，检测日期获取 检测资源（某日的预约挂号资源）
    _getMedResource() {
      if (this.formAppointment.orgUuid == "") {
        this.$message.error("请先选择检测地点！");
        return;
      }
      if (this.formAppointment.date == "") {
        this.$message.error("请先选择预约时间！");
        return;
      }
      let params =
        this.formAppointment.orgUuid +
        "/" +
        Moment(this.formAppointment.date).format("YYYY-MM-DD");
      getResource(params)
        .then((res) => {
          if (res.success) {
            //如果选择的日期 无挂号资源则给出提示，并将资源设为空数组
            if (res.data.length == 0) {
              this.$message({
                type: "warning",
                message: "您选择的日期，已无挂号资源，请重选",
              });
              this.medResources = res.data;
              return;
            }
            //如果选择的日期，有挂号资源，
            this.medResources = res.data;
          } else {
            this.$message({ type: "error", message: res.description });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //获取用户预约的资源
    _getUserBookedResource(reloadData, showMessage = true) {
      getUserBookedResource(this.teleNum)
        .then((res) => {
          //如果接口调用成功，且有预约资源（res.data存在 ）
          if (res.success) {
            //如果已经预约，则将状态设为 已预约
            this.appointment.hasBooked = true;
            //如果点击 网上预约、而且已经预约，则直接进入确定预约tab
            this.tabs.activeName = "confirmAppointment";

            //是否显示提示信息
            if (showMessage) {
              this.$message({
                type: "success",
                message: "发现您已预约！请进入'网上预约'查看",
              });
            }

            //如果有预约记录,则将状态设置为已经预约
            if (res.data) {
              this.myAppointmentInfo.bookedTime = res.data[0].checkTime;
              this.myAppointmentInfo.medResourceName =
                res.data[0].medResourceName;
              if (reloadData) {
                reloadData();
              }
            }
          } else {
            //如果未预约，则将状态设为 未预约
            this.appointment.hasBooked = false;
            //如果点击 网上预约、而且未预约，则进入用户信息tab
            this.tabs.activeName = "userInfo";
            //没有预约资源的提示
            this.$message({
              message: "发现您还未预约，欢迎来预约检查",
              type: "info",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e,
            type: "error",
          });
        });
    },
    //预约挂号
    _appointment() {
      let teleNum = this.formBasicInfo.userInfoTeleNum;
      let params = {
        checkTime: this.formAppointment.checkTime,
        orgId: this.formAppointment.orgUuid,
        resourceLeft: 0,
        resourceUuid: this.formAppointment.resourceUuid,
        total: 1,
      };
      if (
        params.checkTime != "" &&
        params.orgId != "" &&
        params.resourceUuid != ""
      ) {
        // params.teleNum,
        bookMedResource(teleNum, params)
          .then((res) => {
            if (res.success) {
              this.$message({
                message: res.description,
                type: "success",
              });
              //状态变为 已经预约; 转到恭喜应预约 界面
              this.appointment.hasBooked = true;
              //清空已选择的预约时间
              this.formAppointment.checkTime = "";
              this.formAppointment.resourceUuid = "";
            } else {
              this.$message({ message: res.description, type: "warning" });
            }
          })
          .catch((e) => {
            this.$message({ message: e, type: "error" });
          });
      } else {
        this.$message({ message: "请选择挂号资源后再预约", type: "success" });
      }
    },

    _checkAppointmentInfo() {
      this.appointment.myAppointmentInfoDialog = true;
      (this.myAppointmentInfo.name = this.formBasicInfo.name),
        // this.myAppointmentInfo.age =  new Date().getFullYear() - new Date(this.formBasicInfo.birthDate).getFullYear(),
        (this.myAppointmentInfo.age = Formatter_ageFormatter(
          this.formBasicInfo.birthDate
        )),
        (this.myAppointmentInfo.orgUuid = "1");
      this.myAppointmentInfo.credential = "您的电话" + this.teleNum;
    },
    _cancelBookedResource() {
      cancelBookedResource(this.formBasicInfo.userInfoTeleNum)
        .then((res) => {
          if (res.success) {
            this.$message({ message: res.description, type: "success" });
            //将状态改为未预约
            this.appointment.hasBooked = false;
            //关闭预约信息对话框
            this.appointment.myAppointmentInfoDialog = false;
            //清空选择的预约资源
            // 将网上预约tab 改为 用户信息填入tab
            this.tabs.activeName = "userInfo";
          } else {
            this.$message({ message: res.description, type: "error" });
          }
        })
        .catch((e) => {
          this.$message({ message: e, type: "error" });
        });
    },
    //重新加载、显示客户预约详情
    _reloadClientBookInfo() {
      let showMessage = false;
      this._getUserBookedResource(this._checkAppointmentInfo, showMessage);
    },

    _getUserAfterExam() {
      getUserAfterExam(this.teleNum)
        .then((res) => {
          if (res.success) {
            alert(res.data[0]);
          } else {
            this.$message({ message: res.description, type: "error" });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    //获取用户所有的检测记录；
    _getUserAllExam() {
      getUserAllExam(this.teleNum)
        .then((res) => {
          if (res.success) {
            if (res.data[0].length > 0) {
              if (res.data[0][res.data[0].length - 1].prescription) {
                this.prescription =
                  res.data[0][res.data[0].length - 1].prescription;
              } else {
                this.prescription = "暂无";
              }
            } else {
              this.prescription = "暂无";
            }
            console.log(
              "prescription",
              res.data[0][res.data[0].length - 1].prescription
            );
          } else {
            this.$message({ message: res.description, type: "error" });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },

  beforeCreate() {
    document.getElementsByTagName("body")[0].className = "add_bg";
  },
  beforeDestroy() {
    document.body.removeAttribute("class", "add_bg");
  },
  created() {
    //如果getCurrentUser获取不到，则在其函数内重新调用getUserInfo
    this._getCurrentUser();
    // this._getUserInfo();
    // this._getUserMedHistory();
    this._getMedResource();
    this._getUserBookedResource();
    this._getUserAllExam();
  },
};
</script>

<style>
/* body {
  background: linear-gradient(to bottom, #77bbe3, #4285c3) !important;
} */
.add_bg {
  background: linear-gradient(to bottom, #77bbe3, #4285c3);
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang=less>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 3px;
}
.timeSelect {
  margin-bottom: 20px;
}

.content {
  margin-top: 10%;
}

.tabPadding {
  padding-left: 50px;
  padding-right: 50px;
}

.el-tabs__item {
  width: 33% !important;
}

.myBox {
  padding: 20px;
}

/* .myBox .el-row {
  border-bottom: 1px solid lightgray;
} */

/**------------------- input button style  -------------------------*/
.fullWidth {
  width: 100%;
}
/** --------------------------------------------------------------- */
/* ._form_item{
  border: 0.5px solid gray;
  margin-left:10px;
} */


/** index main page body: two main button: book and check-diagnose  */
.box-card {
  width: 280px;
  text-align: center;
  border-radius: 20px;
  /* box-shadow: 0 0 20px gray; */
}

.box-card:hover{
  box-shadow: 5px 5px 10px #010109;
}

.el-card {
  cursor: pointer;
}

.indexImg {
  margin: 50px auto 0 auto;
  width: auto;
  height: 65px;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
/** --------------------------------------------------------------- */
</style>
